import Feed from "../../src/app/feed/pages/Feed"
export default Feed
